import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import { forwardRef } from "react";

// eslint-disable-next-line react/display-name
const Page = forwardRef(({ children, title = "", meta, ...other }, ref) => {

  return (
    <>
      <Helmet>
        <title>{`${title} | POSITEASY`}</title>
        {meta}
      </Helmet>

      <div ref={ref} {...other}>
        {children}
      </div>
    </>
  );
});

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  meta: PropTypes.node,
};

export default Page;
